import React from 'react';
interface TabsProps {
  tabs: {
    id: string;
    label: string;
  }[];
  activeTab: string;
  onChange: (id: string) => void;
  className?: string;
}
export function Tabs({
  tabs,
  activeTab,
  onChange,
  className = ''
}: TabsProps) {
  return <div className={`border-b border-slate-200 ${className}`} data-id="element-236">
      <nav className="-mb-px flex space-x-8 overflow-x-auto" aria-label="Tabs" data-id="element-237">
        {tabs.map(tab => {
        const isActive = activeTab === tab.id;
        return <button key={tab.id} onClick={() => onChange(tab.id)} className={`
                whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors
                ${isActive ? 'border-blue-900 text-blue-900' : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'}
              `} aria-current={isActive ? 'page' : undefined} data-id="element-238">
              {tab.label}
            </button>;
      })}
      </nav>
    </div>;
}